import { useEffect, useMemo, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import ResultsTable from "../Layouts/ResultsTable/resultsTable";
import Spinner from "../Layouts/Spinner/spinner";
import { getSearchResult } from "../../api/searchApi";
import ViewHeader from "../Layouts/ViewHeader/ViewHeader";

export default function Cart() {
    const {
        cartContext: { formBuilderCart },
        notificationsContext
    } = useOutletContext();
    const [cartDisplay, setCartDisplay] = useState([]);
    const [isSearching, setIsSearching] = useState(false);

    const addLinks = useMemo(() => {
        return (<>
            <p><Link to="/cde-catalog">Add fields from CDE Catalog</Link></p>
            <p><Link to="/crf-library">Add Standard template from CRF Library</Link></p>
        </>)
    }, []);

    useEffect(() => {
        const doFetch = async () => {
            setIsSearching(true);
            setCartDisplay(null);

            const body = { reportType: 'CDE_CART' };
            body.cartIds = formBuilderCart;

            const cart = await getSearchResult("CdeCatalog", body);
            setCartDisplay(cart);
            setIsSearching(false);
        };

        // lets not send an empty request to the backend
        if (!formBuilderCart.length)
            return;

        // no need to query the backend if the updated cart is a subset of the displayed one (removals)
        if (formBuilderCart.every(id => cartDisplay.some(r => `${r.cdeId}_${r.crfId}_${r.diseaseId}` === id))) {
            setCartDisplay(prevCart => {
                let newCart = [...prevCart];

                newCart = newCart.filter(r => formBuilderCart.some(id => id === `${r.cdeId}_${r.crfId}_${r.diseaseId}`));

                return newCart;
            });

            return;
        }

        doFetch();
    }, [formBuilderCart]);

    if (!formBuilderCart.length) {
        return (
            <>
                <h3>The cart is currently empty.</h3>
                {addLinks}
            </>
        );
    }

    return (
        <>
            <ViewHeader>
                <p>The <em>Form Builder</em> cart page.</p>
                {addLinks}
            </ViewHeader>
            {isSearching && <Spinner />}
            {cartDisplay && <ResultsTable data={cartDisplay} reportType="CDE_CART" notificationsContext={notificationsContext} />}
        </>
    );
}